import styled from 'styled-components/macro'
import { backgroundColor, textColor } from 'styles'

export const CommentStyled = styled.div`
  margin-top: 20px;
  padding: 20px;
  background: ${backgroundColor};
  overflow: hidden;
  min-height: 70px;
  border: 2px solid ${backgroundColor};
  box-sizing: border-box;
  box-shadow: -10px -10px 20px rgba(8, 21, 45, 0.4), 5px 5px 15px rgba(5, 12, 27, 0.6);
  border-radius: 10px;
`

export const CommentGrid = styled.div`
  display: grid;
  grid-template-columns: 30px auto 200px;
  grid-gap: 10px;
`

export const CommentContent = styled.div``

export const CommentText = styled.div<{ expanded: boolean }>`
  margin-top: 4px;
  display: block;
  max-height: ${(props) => (props.expanded ? '1200px' : '400px')};
  transition: max-height 1s ease;
  overflow: hidden;
  white-space: pre-wrap;

  ::first-letter {
    text-transform: capitalize;
  }
`

export const CommentImage = styled.img`
  max-height: 400px;
  max-width: 100%;
`

export const CommentActions = styled.div`
  margin-top: 10px;
  display: grid;
  grid-template-columns: repeat(4, fit-content(150px));
  grid-gap: 20px;

  > div {
    font-size: 12px;
    font-weight: 600;
    line-height: 15px;
  }
`

export const CommentAction = styled.div`
  font-size: 12px;
  font-weight: 600;
  line-height: 15px;
  cursor: pointer;

  > svg {
    height: 15px;
    width: 15px;
    stroke: ${textColor};
    margin-right: 5px;
    vertical-align: sub;
  }
`

export const CommentInfo = styled.div`
  font-size: 12px;
  font-weight: 600;
  line-height: 15px;
  color: ${textColor};

  > svg {
    height: 15px;
    width: 15px;
    stroke: ${textColor};
    margin-right: 5px;
    vertical-align: sub;
  }
`

export const CommentExpand = styled.div`
  cursor: pointer;
`

export const CommentReply = styled.div`
  padding-left: 15px;
  border-left: 5px solid ${backgroundColor};
`
